import { Spacer } from '../../../components/atoms/spacer/Spacer';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import React from 'react';

const SIZE_MAP = {
  none: '0',
  xxs: '4',
  xs: '8',
  sm: '12',
  md: '16',
  lg: '20',
  xl: '24',
};

const HorizontalSpacerTastic = ({ data, context }) => {
  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  const size = data.size || 'xl';
  const defaultSize = data.desktopSpaceInPx || SIZE_MAP[size];
  const desktopSpaceInPx = data.desktopSpaceInPx || defaultSize;
  const tabletSpaceInPx = data.tabletSpaceInPx || defaultSize;
  const mobileSpaceInPx = data.mobileSpaceInPx || defaultSize;

  return (
    <Spacer
      data={data}
      tabletSpaceInPx={tabletSpaceInPx}
      desktopSpaceInPx={desktopSpaceInPx}
      mobileSpaceInPx={mobileSpaceInPx}
    />
  );
};

export default tastify({ translate: true, connect: { context: true } })(HorizontalSpacerTastic);
